import React from 'react'
import { ModalRoutingContext } from 'gatsby-plugin-modal-routing-3'
import Layout from '../layout/layout'
import { Link } from 'gatsby'
import RegistrationForm from '../components/registrationForm'
import SEO from "../layout/seo"

const pageContent = (<>
        
        <div style={{
            minHeight: `470px`
        }}>
            <RegistrationForm />
            </div>

    </>)


const register = () => {
    
    
    return (

        <ModalRoutingContext.Consumer>
            {({ modal, closeTo }) => (
                <>
                    { modal ? (
                        <main><Link className="closeIcon" to={closeTo}><span>Close</span></Link>
                            <div id="register-page">
                                <h2><span className="turquoise">Ignite Summit</span><br/> Recorded Sessions</h2>
                                <h3>Register and start watching all 14 sessions</h3>
                                {pageContent}
                            </div>

                            <div id="register-complete-page" className="hidden">
                                <h2>Registration Complete!<br/><span className="turquoise">See you on June 14, 2022</span><br/>&nbsp;</h2>

                                <div class="marketoEmbedForm">
                                    <div class="mktoForm">
                                        <p>In the meantime, check out the brand new <a href="https://ignite.apache.org/" target="_blank" className="external turquoise">Apache Ignite website</a>.</p>
                                        <p>While visiting the site you can learn about key Ignite features, download the latest software release and join the community email forum.</p>
                                        <p>We will send Ignite summit updates about the speakers and sessions as we get closer to the event.</p>
                                    </div>
                                </div>
                            </div>
                        </main>
                    ) : (
                        <Layout>
                            <SEO title="Ignite Summit 2022 Registration" description="Register for Apache Ignite Summit 2022 virtual event." />
                            <div className="container register-page">
                                <h2><span className="turquoise">Ignite Summit</span> Recorded Sessions</h2>
                                <h3>Register and start watching all 14 sessions.</h3>
                                {pageContent}
                            </div>
                        </Layout>
                    )}
                </>
            )}
            
        </ModalRoutingContext.Consumer>
    )
}

export default register
